import { ReactComponent as RefreshIcon } from "../../../assets/icons/refresh-ccw-dot.svg";

const IconRefresh: React.FC = () => {
  return (
    <RefreshIcon
      width="24px"
      height="24px"
      style={{
        padding: "1px",
      }}
    />
  );
};

export default IconRefresh;
